<template>
  <li
    :class="[
      'flex gap-4 text-gray-500 dark:text-gray-400',
      playing && 'bg-gray-50 border dark:bg-gray-800 -m-2 p-2 rounded-xl',
    ]"
  >
    <player-link v-slot="{ activator }" autoplay v-bind="{ episode, playlist, theme }">
      <l-button
        class="group relative block border size-16 sm:size-32 aspect-square rounded-lg"
        :href="episode.url"
        :title="`Listen to Episode #${episode.id} in the ${config('app.name')} player`"
        :aria-current="playing || undefined"
        @click.prevent="activator"
      >
        <img
          :src="(playlist ?? episode).image_url"
          class="aspect-square object-cover size-full rounded-lg"
          decoding="async"
          loading="lazy"
          alt=""
        >

        <div
          class="
            bg-white/75 text-blue text-4xl sm:text-6xl rounded-lg
            absolute inset-0 flex size-full items-center justify-center
            dark:bg-black/75 dark:text-white
            invisible group-hover:visible
          "
        >
          <icon name="play"/>
        </div>
      </l-button>

      <div class="grid gap-1.5">
        <h3>
          <l-button
            v-if="plyr"
            :href="episode.url"
            class="font-medium text-blue dark:text-white text-lg"
            :aria-current="playing || undefined"
            @click.prevent="activator"
          >
            {{ episode.title }}
          </l-button>
          <a v-else :href="episode.url" class="font-medium text-blue dark:text-white text-lg">
            {{ episode.title }}
          </a>
        </h3>

        <p class="line-clamp-2 leading-relaxed">
          {{ episode.excerpt }}
        </p>

        <div class="flex gap-x-6 gap-y-1 text-sm flex-wrap">
          <div v-if="playing" class="flex gap-1 items-center">
            <icon name="play" class="text-gray-300 dark:text-gray-500"/>
            Now playing
          </div>
          <div class="flex gap-1 items-center">
            <icon name="episode" class="text-gray-300 dark:text-gray-500"/>
            <span class="hidden sm:inline">Episode</span>
            #{{ episode.id }}
          </div>
          <div class="flex gap-1 items-center">
            <icon name="date" class="text-gray-300 dark:text-gray-500"/>
            {{ episode.date }}
          </div>
          <div class="flex gap-1 items-center">
            <icon name="duration" class="text-gray-300 dark:text-gray-500"/>
            {{ episode.duration }}
          </div>
        </div>
      </div>
    </player-link>
  </li>
</template>

<script setup>
import Icon from "@/components/Icon.vue"
import LButton from "@/components/buttons/LButton.vue"
import PlayerLink from "@/components/player/PlayerLink.vue"
import { config } from "@/support"

defineProps({
  episode: { type: Object, required: true },
  playlist: Object,
  playing: Boolean,
  theme: String,
})

const plyr = window.plyr
</script>
